import { useState } from "react";
import dispatchService from "services/dispatch.service";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";

export default function CreateDispatchDialog({
    open,
    handleClose,
    products = [],
    organization
}) {
    const [newDispatch, setNewDispatch] = useState({});
    const [errors, setErrors] = useState({});

    const changeHandler = (e) => {
        const { name, value } = e.target;
        setNewDispatch({
            ...newDispatch,
            [name]: value,
        });
    };

    const handleCancel = () => {
        setNewDispatch({});
        setErrors({});
        handleClose();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors({});

        if (!newDispatch.description || !newDispatch.description.trim()) {
            setErrors({ description: "Description is required" });
            return;
        }

        const payload = {
            data: {
                attributes: {
                    description: newDispatch.description.trim(),
                    products: products,
                    organization: organization.id
                },
            },
        };
        console.log("Submitting dispatch with payload:", payload);
        console.log("Organization :", organization);

        await dispatchService.createDispatch(payload);
        console.log("Dispatch payload:", payload);

        setNewDispatch({});
        handleClose();
    };

    return (
        <Dialog open={open} onClose={handleCancel}>
            
            <DialogTitle>
                Initiate Dispatch Request
            </DialogTitle>

            <DialogContent>

                <DialogContentText>
                    To initiate a dispatch for the selected products, please input the description below.
                </DialogContentText>

                <form onSubmit={handleSubmit} id="dispatch-form">
                    <Grid container spacing={1}>
                        <Grid item xs={12}>

                            <MDBox p={1}>
                                <TextField
                                    autoFocus
                                    name="description"
                                    type="text"
                                    multiline
                                    rows={3}
                                    label="Description"
                                    fullWidth
                                    onChange={changeHandler}
                                    value={newDispatch.description || ""}
                                    error={Boolean(errors.description)}
                                    helperText={errors.description}
                                />
                            </MDBox>

                        </Grid>
                    </Grid>
                </form>

            </DialogContent>

            <DialogActions>
                <MDButton color="dark" variant="gradient" size="small" onClick={handleCancel}>
                    Cancel
                </MDButton>
                <MDButton color="dark" variant="gradient" size="small" type="submit" form="dispatch-form">
                    Initiate
                </MDButton>
            </DialogActions>
        </Dialog>
    );
}
